var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="substitutionParam--category">\n  <div class="substitutionParam--category-title">\n    <strong>'+
((__t=( category ))==null?'':_.escape(__t))+
'</strong>\n  </div>\n  <ul id="'+
((__t=( category_id ))==null?'':_.escape(__t))+
'" class="pl-none" style="list-style: none;"></ul>\n</div>\n';
}
return __p;
};
